<template>
  <Catalogs
    title="Статус исполнителя в заявке"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'TaskWorkerStatusAdd'"
    :route-edit="'TaskWorkerStatusEdit'"
    :route-view="'TaskWorkerStatusView'"
    :route-path="'/task_worker_statuses'"
    :can-edit="canEditCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "TaskWorkerStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getTaskWorkerStatuses(data);
    },
    canEditCatalogs() {
      return this.hasPermission([PERM.CATALOG_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskWorkerStatuses/TaskWorkerStatuses.vue